module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-Pile-After-8c89b6aa.jpg";